import { requestBuilder } from '../../http/RequestBuilder';
import type { IBill, PartialBill } from '../types/Bill';

type BillsApiMembershipParam = Pick<IBill, 'membershipId'>;

export type CreateBillBody = Pick<
    IBill,
    | 'accountId'
    | 'name'
    | 'payee'
    | 'amount'
    | 'cadence'
    | 'timingLabel'
    | 'timingDescription'
    | 'category'
    | 'lastPaidAt'
>;

const useCreateBill = requestBuilder.mutation<
    PartialBill,
    CreateBillBody,
    BillsApiMembershipParam
>({
    endpoint: ({ membershipId }) =>
        `/api/holistic-bills/${membershipId}/bill/create`,
    method: 'POST',
});

export default useCreateBill;
